import { TopolImageAndVideoBlock } from "@/schemas/template/blocks/imageAndVideoBlockSchema";
import calcWidth from "./helpers";
import { v4 as uuidv4 } from "uuid";
import { mergeDeep } from "@/utils/mergeDeep";
import {
  ImageAndVideoAttributesSchema,
  TopolCustomBlockData,
  TopolCustomBlockMixContentWithKey,
} from "@/schemas/contentBlock/contentBlockScheme";

export default {
  getData(
    state: any,
    props: { sectionIndex: number; columnIndex: number },
    customBlockData?: TopolCustomBlockData | TopolCustomBlockMixContentWithKey
  ): TopolImageAndVideoBlock {
    const imageDefaults = state.mjml.attributes["mj-image"] || {};
    const attributes: TopolImageAndVideoBlock["attributes"] = {
      src: "",
      alt: "",
      padding: imageDefaults["padding"] || "0px",
      "fluid-on-mobile": imageDefaults["fluid-on-mobile"] || "false",
      href: "",
      containerWidth: calcWidth(
        state.mjml.children[0].attributes["containerWidth"],
        state.mjml.children[0].children[props.sectionIndex].children[
          props.columnIndex
        ].attributes["width"]
      ),
    };

    if (imageDefaults["border-radius"]) {
      (attributes as any)["border-radius"] = imageDefaults["border-radius"];
    }
    if (imageDefaults["align"]) {
      (attributes as any)["align"] = imageDefaults["align"];
    }

    if (customBlockData && customBlockData.attributes) {
      let attributesToMerge: any = {};
      const imageAttributes = ImageAndVideoAttributesSchema.safeParse(
        customBlockData.attributes
      );
      if (imageAttributes.success) {
        attributesToMerge = imageAttributes.data;
      } else {
        const attributesObject = JSON.parse(
          JSON.stringify(customBlockData.attributes)
        );
        imageAttributes.error.issues.map((issue) => {
          delete attributesObject[issue.path[0]];
        });
        const newRes =
          ImageAndVideoAttributesSchema.safeParse(attributesObject);
        attributesToMerge = newRes.success ? newRes.data : {};
      }
      Object.keys(attributesToMerge).map((key) => {
        if (typeof attributesToMerge[key] === "object") {
          attributesToMerge[key] = attributesToMerge[key].value;
        }
      });
      mergeDeep(attributes, attributesToMerge);
    }

    return {
      uid: uuidv4(),
      tagName: "mj-image",
      isVideo: true,
      attributes: attributes,
      customKey: customBlockData?.key ? customBlockData.key : null,
    };
  },
};
